import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { allowSystemPageNavigation } from '../guard/navigation-flag.guard';
import { MsalService } from '@azure/msal-angular';

let isRefreshing = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const msalService = inject(MsalService);
  const token = JSON.parse(localStorage.getItem('tokenId') ?? 'null');

  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((err: HttpErrorResponse) => {
      // Handle 401 Unauthorized - attempt token refresh
      if (err.status === 401 && !isRefreshing) {
        isRefreshing = true;
        const activeAccount = msalService.instance.getActiveAccount();

        if (!activeAccount) {
          isRefreshing = false;
          allowSystemPageNavigation('/login');
          router.navigate(['/login']);
          return throwError(() => err);
        }

        allowSystemPageNavigation('/unauthorized');
        router.navigate(['/unauthorized']);
        isRefreshing = false;
      }
      // Handle 401 when already refreshing - prevent infinite loop
      else if (err.status === 401 && isRefreshing) {
        isRefreshing = false;
        console.error('[Auth Interceptor] Token refresh already in progress, navigating to login');
        allowSystemPageNavigation('/unauthorized');
        router.navigate(['/unauthorized']);
        return throwError(() => err);
      }
      // 400 - treated as recoverable, send user through to workspace
      else if (err.status === 400) {
        console.warn('[Auth Interceptor] 400 received - navigating to workspace');
        allowSystemPageNavigation('/workspace');
        router.navigate(['/workspace']);
      }

      else {
        console.warn(`[Auth Interceptor] HTTP ${err.status} received`);
      }

      return throwError(() => err);
    }),
  );
};
